import React from 'react';

import styles from './styles/index.module.scss';

const Hr = () => <hr className={styles.hr} />;

export default Hr;
